export default __webpack_public_path__ + "static/media/payment-visa.abeef19a.svg";